export default __webpack_public_path__ + "static/media/moneybar.964bcb01.svg";